module.exports = __webpack_public_path__ + "assets/images/Exames Preventivos.7af186d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kit-plans/icons/Exames Preventivos.png
// module id = 795
// module chunks = 1